import { Card, CardContent, Typography, Box } from '@mui/material';
import { Star } from '@mui/icons-material';

const RatingCard = ({ quote, name, title }) => (
  <Card
    sx={{
      borderRadius: 4,
      boxShadow: 0,
      maxWidth: '640px',
      margin: 'auto',
      p: '16px 8px',
      ':last-child': { paddingBottom: 1 },
      textAlign: 'center',
      backgroundColor: '#EAF0FE',
    }}
  >
    <CardContent sx={{ padding: 1, ':last-child': { paddingBottom: 1 } }}>
      <Typography
        variant="body1"
        sx={{ fontSize: '18px', lineHeight: '24px', fontWeight: 400, mb: 2 }}
      >
        "{quote}"
      </Typography>
      <Box sx={{ mb: 1 }}>
        {[...Array(5)].map((_, i) => (
          <Star key={i} sx={{ color: '#F3AF3F', fontSize: 28 }} />
        ))}
      </Box>
      <Typography
        sx={{ fontWeight: 700, lineHeight: '24px', fontSize: '18px', mb: 1 }}
      >
        {name}
      </Typography>
      <Typography
        sx={{ fontWeight: 400, lineHeight: '24px', fontSize: '18px', mb: 1 }}
      >
        {title}
      </Typography>
    </CardContent>
  </Card>
);

export default RatingCard;
